import { iamApiSlice } from './iamApiSlice';

export interface User {
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
}

export interface UserPermission {
  resourceId: string;
  resourceName: string;
  resourceType: string;
  actionId: string;
  actionName: string;
  actionDesc: string;
}

export const userApi = iamApiSlice.injectEndpoints({
  endpoints: builder => ({
    getUsersByOrg: builder.query<User[], void>({
      query: () => `/users`,
      providesTags: ['User'],
    }),
    getMyPermissions: builder.query<UserPermission[], void>({
      query: () => `/users/me/permissions`,
      providesTags: ['User'],
    }),
    deleteMe: builder.mutation<void, void>({
      query: () => ({
        url: `/users/me`,
        method: 'DELETE',
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useGetUsersByOrgQuery,
  useGetMyPermissionsQuery,
  useDeleteMeMutation,
} = userApi;
